"use client";

import { Button } from "@/components/buttons/Button";
import { usePricingModal } from "@/lib/zustand/usePricingModal";
import { UserNoDates } from "@/types/types";
import { cn } from "@/utils/cn";
import { isFreeUser } from "@/utils/subscriptionLevels/isFreeUser";

export function UpgradeButton({
  user,
  closeMobileSidebar,
  className,
}: {
  user: UserNoDates;
  closeMobileSidebar: (() => void) | null;
  className?: string;
}) {
  const setPricingModalOpen = usePricingModal((state) => state.setOpen);

  const clickHandler = () => {
    if (closeMobileSidebar !== null) {
      closeMobileSidebar();
    }
    setPricingModalOpen();
  };

  const freeUser = isFreeUser(user.stripeSubscriptionId);

  if (!freeUser) {
    return null;
  }

  return (
    <Button onClick={clickHandler} className={cn(className, "w-full")}>
      Upgrade
    </Button>
  );
}
